import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import FormField from '../form-field';
import '../../css/resolve-issues-form.css';

export const NOTIFY_MEMBERS_OPTION = 'notify';
export const COVER_SHARES_OPTION = 'cover';
export const REDISTRIBUTE_SHARES_OPTION = 'redistribute';

class ResolvePaymentIssues extends Component {
  renderModalMessage() {
    const failedMembersCount = this.props.failedMemberships.length;
    const shortMembersCount = this.props.shortMemberships.length;

    if (failedMembersCount && shortMembersCount) {
      return (
        <FormattedMessage
          id="resolveIssues.modalMessage.hasIssues"
          defaultMessage="{failedMembersCount} contributor payments failed, and
            {shortMembersCount} contributors need to confirm a higher charge.
            You must take one of the following steps before you can make your
            group's purchase."
          values={{
            shortMembersCount,
            failedMembersCount
          }}
        />
      );
    }

    if (shortMembersCount) {
      return (
        <FormattedMessage
          id="resolveIssues.modelMessage.shortMembers"
          defaultMessage="{shortMembersCount} contributors need to confirm a
            higher charge. You must take one of the following steps before you
            can make your group's purchase."
          values={{ shortMembersCount }}
        />
      );
    }

    return (
      <FormattedMessage
        id="resolveIssues.modalMessage.failedMembers"
        defaultMessage="{failedMembersCount} contributor payments failed.
          You must take one of the following steps before you can make your group's purchase."
        values={{ failedMembersCount}}
      />
    );
  }
  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div className="resolve-payment-issues">
        <div className="modal-section modal-title text-center blue full">
          <h1>
            <FormattedMessage
              id="resolveIssues.title"
              defaultMessage="Resolve payment issues"
            />
          </h1>
        </div>
        <form onSubmit={handleSubmit(this.props.onSubmit)}>
          <div className="mx-4">
            <p>
              {this.renderModalMessage()}
            </p>
            <div className="mt-4">
              <Field
                type="radio"
                name="resolveOption"
                value={NOTIFY_MEMBERS_OPTION}
                label={
                  <FormattedMessage
                    id="resolveIssues.resolveOption.notify.label"
                    defaultMessage="Contact contributors and wait for them to
                      update their payment method."
                  />
                }
                subtext={
                  <FormattedMessage
                    id="resolveIssues.resolveOption.notify.subtext"
                    defaultMessage="We already sent them an alert, but they will be notified again"
                  />
                }
                component={FormField}
              />
              <Field
                type="radio"
                name="resolveOption"
                value={COVER_SHARES_OPTION}
                label={
                  <FormattedMessage
                    id="resolveIssues.resolveOption.cover.label"
                    defaultMessage="Remove them from the group and cover their share yourself."
                  />
                }
                subtext={
                  <FormattedMessage
                    id="resolveIssues.resolveOption.cover.subtext"
                    defaultMessage="The fastest way to complete your purchase"
                  />
                }
                component={FormField}
              />
              <Field
                type="radio"
                name="resolveOption"
                value={REDISTRIBUTE_SHARES_OPTION}
                label={
                  <FormattedMessage
                    id="resolveIssues.resolveOption.redistribute.label"
                    defaultMessage="Remove them from the group and redistribute
                      their share across the group."
                  />
                }
                subtext={
                  <FormattedMessage
                    id="resolveIssues.resolveOption.redistribute.subtext"
                    defaultMessage="Redistributing shares may cause other members to have to
                      accept higher charges before you can complete the purchase."
                  />
                }
                component={FormField}
              />
            </div>
            <hr className="mt-5" />
            <div className="row">
              <div className="col-7" />
              <div className="col-5">
                <button className="btn btn-primary float-right" type="submit" disabled={submitting}>
                  <FormattedMessage
                    id="resolveIssues.submit"
                    defaultMessage="Continue"
                  />
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({ form: 'resolvePaymentIssuesForm' })(ResolvePaymentIssues);



// WEBPACK FOOTER //
// ./src/desktop/components/resolve-payment-issues/index.js